import { render, staticRenderFns } from "./TimelineVertical.vue?vue&type=template&id=516dc9ad"
import script from "./TimelineVertical.vue?vue&type=script&lang=js"
export * from "./TimelineVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports